import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import wishlistListSection from "../../components/wishlistListSection/index.vue";
import wishlistArticleSection from "../../components/wishlistArticleSection/index.vue";
import axios from "axios";

export default {
  name: "wishlistPage",
  components: {
    HeaderSubSection,
    wishlistListSection,
    wishlistArticleSection,
  },
  data() {
    return {
      AllUser: [],
      linkUser: "",
      shareLink: [],
      testingCode: "",
    };
  },
  created() {
    // this.getUsers();
  },
  methods: {
    serachUser() {
      console.log("test");
      // var userLink = {
      //   link: this.linkUser,
      // };
      axios
        .post("https://giftstore-blog.herokuapp.com/api/user/getUserByLink", {
          link: this.linkUser,
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.user.length == 0) {
            var btn = `<p class="messageUser">Votre ami(e) n'est pas encore un membre G store, inviter le et échanger les cadeaux</p>
                      <a class='user-share-btn' href='https://www.facebook.com/sharer/sharer.php?u=https://www.giftstore.tn/' rel='nofollow'
                        target='_blank'>Partage sur facebook</a>`;
            this.shareLink.push(btn);
          } else {
            this.shareLink = "";
            var userLink =
              "wishlist-friend?idActive=" + response.data.user[0]._id;
            this.$store.commit("setActiveUser", response.data.user[0]._id);
            this.$router.push({ path: userLink });
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
          // this.$toast.open({
          //   message: "ami bien ajouté",
          //   type: "success",
          //   // all of other options may go here
          // });
        });
    },
    // getUsers() {
    //   var userId = {
    //     userId: window.localStorage.getItem("Giftstore-U"),
    //   };
    //   axios
    //     .post(
    //       "https://giftstore-blog.herokuapp.com/api/user/friend/getAllUsers",
    //       userId
    //     )
    //     .then((response) => {
    //       console.log("batata", response);
    //       this.AllUser = response.data.users;
    //     })
    //     .catch((error) => {
    //       console.error("There was an error!", error);
    //     });
    // },
    // UserName(firstName, lastName) {
    //   return firstName + " " + lastName;
    // },
    // addUserFriend(id) {
    //   var data = {
    //     userId: window.localStorage.getItem("Giftstore-U"),
    //     friendId: id,
    //   };
    //   axios
    //     .post("https://giftstore-blog.herokuapp.com/api/user/friend/add", data)
    //     .then((response) => {
    //       this.getUsers();
    //       this.$toast.open({
    //         message: "ami bien ajouté",
    //         type: "success",
    //         // all of other options may go here
    //       });
    //     })
    //     .catch((error) => {
    //       console.error("There was an error!", error);
    //     });
    // },
  },
};
